(function (w) {
  var init_number_filter = function (id, min, max, default_min, default_max, filterWasActive) {
    var min_obj = $("#" + id + "_min"),
        max_obj = $("#" + id + "_max"),
        form = min_obj.parents('form.j-number-form'),
        reset = form.find('.j-reset'),

        min_name = min_obj.attr('name') ? min_obj.attr('name') : min_obj.attr('data-name'),
        max_name = max_obj.attr('name') ? max_obj.attr('name') : max_obj.attr('data-name');
    if (filterWasActive == undefined) {
      filterWasActive = false;
    }
    min_obj.attr('data-name', min_name);
    max_obj.attr('data-name', max_name);

    min_obj.parents('form:first').find('[name="' + min_name + '"][type="hidden"],[name="' + max_name + '"][type="hidden"]').remove();

    var check_values = function () {
      var min = min_obj.val() * 1,
          max = max_obj.val() * 1,

          remove_min = min <= default_min * 1,
          remove_max = max >= default_max * 1;
      if (!filterWasActive || (remove_min && remove_max)) {
        min_obj.removeAttr('name');
        max_obj.removeAttr('name');
      } else {
        min_obj.attr('name', min_name);
        max_obj.attr('name', max_name);
      }

      filterWasActive = true;
    };

    var slider = $("#" + id).slider({
      range: true,
      min: default_min,
      max: default_max,
      values: [min, max],
      slide: function (event, ui) {
        var min_val = ui.values[0],
            max_val = ui.values[1];

        if (min_val >= max_val) {
          var modifier = max_val != default_min ? -1 : 0;
          min_val = max_val + modifier;
        }

        if (max_val <= min_val) {
          var modifier = min_val != default_max - 1 ? +1 : 0;
          max_val = min_val + modifier;
        }
        slider.slider('values', 0, min_val);
        slider.slider('values', 1, max_val);
        min_obj.val(min_val);
        max_obj.val(max_val);

        check_values();
      }
    });

    var handles = slider.find('.ui-slider-handle');
    if (handles.length >= 2) {
      handles.eq(0).attr({'role': 'slider', 'aria-valuemin': default_min, 'aria-valuemax': default_max, 'aria-valuenow': min, 'aria-label': min_obj.attr('aria-label') || 'min', 'tabindex': '0'});
      handles.eq(1).attr({'role': 'slider', 'aria-valuemin': default_min, 'aria-valuemax': default_max, 'aria-valuenow': max, 'aria-label': max_obj.attr('aria-label') || 'max', 'tabindex': '0'});
    }

    min_obj.on('change', function () {
      var me = $(this),
          val = me.val() * 1;

      if (val < default_min) {
        val = default_min;
      } else if (val > max_obj.val() * 1) {
        val = max_obj.val() * 1;
      }
      me.val(val);
      slider.slider('values', 0, val);

      check_values();
    });

    max_obj.on('change', function () {
      var me = $(this),
          val = me.val() * 1;

      if (val > default_max) {
        val = default_max;
      } else if (val < min_obj.val() * 1) {
        val = min_obj.val() * 1;
      }
      me.val(val);

      slider.slider('values', 1, val);

      check_values();
    });
    reset.on('click', function () {
      if (min_obj.val() != default_min || max_obj.val() != default_max) {
        slider.slider('values', 0, default_min);
        min_obj.val(default_min);
        slider.slider('values', 1, default_max);
        max_obj.val(default_max);

        check_values();
        form.submit();
      }
    });

    form.off('submit').on('submit', function (e) {
      e.preventDefault();

      var min_val       = min_obj.val() * 1,
          max_val       = max_obj.val() * 1,
          submit_button = $(document.activeElement);

      if (min_val <= default_min * 1 && max_val >= default_max * 1) {
        min_obj.prop('disabled', true);
        max_obj.prop('disabled', true);
      }

      let link  = $(e.target).data('url'),
          fName = $(e.target).data('filer-name');

      link = link.replace(fName + '=min-max', fName + `=${min_val}-${max_val}`);
      CatalogBuilder.followFilter(link, true);

      if (submit_button.length && form.has(submit_button)) {
        submit_button.addClass('__disabled').append('<div class="loader">');
      }

      return false;
    });
    check_values();
  };

  w.init_number_filter = init_number_filter;
})(window);